import {
	useDecisionMakerProfilePageData,
	useDMProfilePagePaginatedTargetedPetitionsData,
} from 'src/app/pages/decisionMakerProfile/pageContext';
import { useMultipleQueryParamsValue } from 'src/app/shared/hooks/location';
import { useTrackView } from 'src/app/shared/hooks/tracking';

import { useResponsivenessScoreEnabled } from '../useResponsivenessScoreEnabled';

type Result = ModelHookResult<{
	dmReputationLayer: {
		isDmrlEnabled: boolean;
		hasTopIssues: boolean;
		hasCampaignPhotoOrWebsites: boolean;
		hasEndorsements: boolean;
	};
}>;

export function useLayout(): Result {
	const [sourceLocation, showDmrl] = useMultipleQueryParamsValue(['source_location', 'showDmrl']);
	const {
		data: {
			id,
			type,
			verifiedAt,
			enrichedData,
			featureConfigs: { dmReputationLayer },
		},
	} = useDecisionMakerProfilePageData();

	const {
		data: { totalCount: petitionCount },
	} = useDMProfilePagePaginatedTargetedPetitionsData();

	const responsivenessScoreEnabled = useResponsivenessScoreEnabled();

	const isDmrlEnabled = dmReputationLayer.enabled || showDmrl === 'true';

	useTrackView(
		'dm_show_view',
		{
			dm_id: `dm_${id}`,
			dm_verified: !!verifiedAt,
			dm_type: type,
			dm_petitions_num: petitionCount,
			source_location: sourceLocation,
			dm_responsiveness_score_enabled: responsivenessScoreEnabled,
		},
		[],
	);

	const hasTopIssues = (enrichedData?.issues ?? []).length > 0;
	const hasCampaignPhoto = !!enrichedData?.campaignPhotoUrl;
	const hasWebsitesData = (enrichedData?.websites ?? []).length > 0;
	const hasEndorsements = !!enrichedData?.endorsementsOverview?.summary;
	const hasCampaignPhotoOrWebsites = hasCampaignPhoto || hasWebsitesData;

	return {
		data: {
			dmReputationLayer: { isDmrlEnabled, hasTopIssues, hasCampaignPhotoOrWebsites, hasEndorsements },
		},
	};
}
